import { CounterpartySagaWatcher } from './Counterparties/services/saga';
import { PackagingSagaWatcher } from './Packaging/services/saga';
import { ProductSagaWatcher } from './Products/services/saga';
import { WithdrawalSagaWatcher } from './Withdrawal/services/saga';

export const handbookModuleSaga = [
  CounterpartySagaWatcher,
  PackagingSagaWatcher,
  ProductSagaWatcher,
  WithdrawalSagaWatcher,
];
